import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import imageSrc from '../../assets/images/slide/start-memoir-tablet-photos.png';
import styles from './StartSlideV10.css';

function StartSlideV10({ id, onContinue }) {
    const handleChange = label => () => {
        logEvent(EVENT_TYPES.QUIZ_START_CLICKED, { label });
        onContinue();
    };

    return (
        <div className={styles.form} key={id}>
            <ul className={styles.badges}>
                <li className={styles.badge}>
                    <span className={styles.badgeIcon}>
                        <Icon name='micFilled' />
                    </span>
                    <span className={styles.badgeText}>Speak or type</span>
                </li>
                <li className={styles.badge}>
                    <span className={styles.badgeIcon}>
                        <Icon name='lockFilled' />
                    </span>
                    <span className={styles.badgeText}>Private by default</span>
                </li>
            </ul>
            <div className={styles.imageWrapper}>
                <img src={imageSrc} alt='' className={styles.image} />
            </div>
            <h1 className={styles.heading}>Have you ever wanted to tell your life story?</h1>
            <p className={styles.subheading}>Take the 2-minute quiz</p>
            <div className={styles.answers}>
                <button type='button' onClick={handleChange('No')} className={styles.answerButton}>
                    <span className={styles.answerText}>No</span>
                    <span className={styles.answerIcon}>
                        <Icon name='chevronRight' />
                    </span>
                </button>
                <button type='button' onClick={handleChange('Yes')} className={styles.answerButton}>
                    <span className={styles.answerText}>Yes</span>
                    <span className={styles.answerIcon}>
                        <Icon name='chevronRight' />
                    </span>
                </button>
            </div>
        </div>
    );
}

StartSlideV10.propTypes = {
    id: PropTypes.number.isRequired,
    onContinue: PropTypes.func.isRequired
};

export {
    StartSlideV10
};
